// @flow

import * as React from 'react';

type Props = {
  width: string,
  height: string,
  className?: string,
};

export default class Close extends React.Component<Props> {
  static defaultProps = {
    width: '100%',
    height: '100%',
  };

  render() {
    return (
      <svg
        viewBox="-1 0 19 18"
        className={this.props.className}
        width={this.props.height}
        height={this.props.width}
        style={{ fill: 'currentColor' }}
      >
        <path d="M10.192,8.778 L17.262,1.708 C17.654,1.316 17.654,0.684 17.262,0.293 C16.872,-0.097 16.24,-0.097 15.849,0.293 L8.774,7.363 L1.704,0.293 C1.315,-0.097 0.68,-0.097 0.29,0.293 C-0.1,0.683 -0.1,1.316 0.29,1.707 L7.36,8.777 L0.29,15.85 C-0.1,16.24 -0.1,16.87 0.29,17.26 C0.486,17.456 0.74,17.554 0.998,17.554 C1.252,17.554 1.508,17.456 1.704,17.261 L8.774,10.191 L15.846,17.261 C16.041,17.458 16.296,17.556 16.552,17.556 C16.808,17.556 17.064,17.458 17.259,17.263 C17.649,16.873 17.649,16.241 17.259,15.85 L10.189,8.777 L10.192,8.778 Z" />
      </svg>
    );
  }
}
